import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './icon-button.css'

const IconButton = ({ label, children, onClick }) => (
  <button styleName="icon-button" onClick={onClick}>
    <span styleName="icon">
      {children}
    </span>
    {label &&
      <span styleName="label">
        {label}
      </span>
    }
  </button>
)

IconButton.propTypes = {
  label: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func,
}

export default CSSModules(IconButton, styles)



/** WEBPACK FOOTER **
 ** ./src/components/icon-button/icon-button.js
 **/